import React from "react";
import { BlockMath, InlineMath } from "react-katex";
import SqrtInput, {
  getSqrtInputNumericValue,
} from "../../../../components/inputs/SqrtInput";
import {
  buildData,
  cosineGivenValueCases,
  rootLatex,
} from "../../temat1_trojkaty/podtemat9_twierdzenie_cosinusow_types/FindSideFromTwoSidesAndCosineTask";

const pick = (items) => items[Math.floor(Math.random() * items.length)];

export function generateTask(options = {}) {
  const original = options.variant === "original" && options.session === "2024_SIE";
  const values = original
    ? { ab: 5, ac: 2, numerator: 3, denominator: 5 }
    : pick(cosineGivenValueCases);

  return {
    type: "MaturaCosineGivenValueOpenTask",
    data: { ...buildData(values), maxPoints: 1 },
    ...(original ? {
      source: {
        variant: "original",
        exam: "MATURA",
        session: "2024_SIE",
        taskNumber: "18",
      },
    } : {}),
  };
}

export function renderTask({ data }) {
  return (
    <div style={{ textAlign: "left" }}>
      <p><strong>Zadanie maturalne – otwarte (0–1 pkt).</strong></p>
      <p>
        Dany jest trójkąt <InlineMath math="ABC" />, w którym{" "}
        <InlineMath math={`|AB|=${data.ab}`} />,{" "}
        <InlineMath math={`|AC|=${data.ac}`} /> oraz{" "}
        <InlineMath math={`\\cos |\\angle BAC|=\\frac{${data.numerator}}{${data.denominator}}`} />.
      </p>
      <p>Oblicz długość boku <InlineMath math="BC" />.</p>
    </div>
  );
}

export function renderInput(_task, value, onChange, disabled) {
  return <SqrtInput value={value} onChange={onChange} disabled={disabled} label="|BC|" />;
}

export function checkAnswer({ data }, value) {
  const parsed = getSqrtInputNumericValue(value);
  return Number.isFinite(parsed) && Math.abs(parsed - Math.sqrt(data.radicand)) < 1e-9;
}

export function renderAnswer({ data }) {
  return <InlineMath math={`|BC|=${rootLatex(data.radicand)}`} />;
}

export function renderUserAnswer(value) {
  const raw = String(value?.raw ?? value ?? "").trim();
  if (!raw) return <i>(brak odpowiedzi)</i>;
  const latex = raw
    .replace(/sqrt\s*\(?\s*(\d+)\s*\)?/gi, "\\sqrt{$1}")
    .replace(/(\d*)√(\d+)/g, (_match, coefficient, radicand) => `${coefficient}\\sqrt{${radicand}}`);
  return <InlineMath math={`|BC|=${latex}`} />;
}

export function renderExplanation({ data }) {
  const sum = data.ab ** 2 + data.ac ** 2;
  return (
    <div style={{ textAlign: "left" }}>
      <p><strong>Krok 1.</strong> Stosujemy twierdzenie cosinusów.</p>
      <BlockMath math={String.raw`|BC|^2=|AB|^2+|AC|^2-2\cdot |AB|\cdot |AC|\cdot \cos |\angle BAC|`} />
      <p><strong>Krok 2.</strong> Podstawiamy dane.</p>
      <BlockMath math={`|BC|^2=${data.ab}^2+${data.ac}^2-2\\cdot ${data.ab}\\cdot ${data.ac}\\cdot \\frac{${data.numerator}}{${data.denominator}}`} />
      <BlockMath math={`|BC|^2=${sum}-${data.subtracted}=${data.radicand}`} />
      <p><strong>Krok 3.</strong> Długość boku jest dodatnia.</p>
      <BlockMath math={`|BC|=${rootLatex(data.radicand)}`} />
    </div>
  );
}
